export default function HeroSection() {
  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center pt-[72px] overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20warm%20gradient%20background%20with%20soft%20glowing%20orange%20and%20amber%20tones%2C%20subtle%20cinematic%20film%20grain%20texture%2C%20elegant%20dark%20overlay%2C%20luxurious%20atmospheric%20mood%2C%20modern%20streaming%20entertainment%20aesthetic%2C%20smooth%20radial%20light%20leak%20effect%2C%20premium%20cinema%20feel&width=1600&height=1000&seq=durian-hero-bg&orientation=landscape"
          alt="榴莲视频平台背景"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-12 md:py-20">
        <div className="max-w-[1280px] mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
            <div className="flex-1 w-full text-center lg:text-left">
              <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/15 backdrop-blur-sm border border-background-50/20 mb-6">
                <span className="w-2 h-2 rounded-full bg-accent-400 animate-pulse"></span>
                <span className="text-xs font-medium text-background-100 whitespace-nowrap">
                  97视频 · 丝瓜视频 · 蓝莓视频 · 91在线视频
                </span>
              </div>

              <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight font-heading">
                榴莲视频
                <span className="block text-accent-300 mt-1">
                  在线视频平台综合对比导航
                </span>
              </h1>

              <p className="mt-4 text-lg md:text-xl text-background-200/90 font-heading italic">
                一站打通热门平台，观影选择不再纠结
              </p>

              <p className="mt-6 text-sm md:text-base text-background-200/80 leading-relaxed max-w-xl mx-auto lg:mx-0">
                榴莲视频汇集97视频、丝瓜视频、蓝莓视频、91在线视频、糖心视频、黑桃视频等热门在线视频平台，提供全方位平台对比、最新动态追踪和观影导航服务。无论你是寻找新平台的探索者，还是想了解各平台特色的资深用户，这里都能帮你快速做出选择。
              </p>

              <div className="mt-8 flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-10">
                <div className="text-center">
                  <p className="text-2xl md:text-3xl font-bold text-accent-300 font-heading">
                    7+
                  </p>
                  <p className="text-xs text-background-300 mt-1 whitespace-nowrap">核心平台覆盖</p>
                </div>
                <div className="text-center">
                  <p className="text-2xl md:text-3xl font-bold text-accent-300 font-heading">
                    每日更新
                  </p>
                  <p className="text-xs text-background-300 mt-1 whitespace-nowrap">动态追踪</p>
                </div>
                <div className="text-center">
                  <p className="text-2xl md:text-3xl font-bold text-accent-300 font-heading">
                    安全导航
                  </p>
                  <p className="text-xs text-background-300 mt-1 whitespace-nowrap">信息对比</p>
                </div>
              </div>

              <div className="mt-8 flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
                <a
                  href="#index"
                  className="px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold rounded-lg transition-colors text-sm whitespace-nowrap cursor-pointer"
                >
                  浏览热门专题
                  <i className="ri-arrow-right-line ml-2"></i>
                </a>
                <a
                  href="#ranking"
                  className="px-6 py-3 bg-background-50/10 hover:bg-background-50/20 text-background-100 border border-background-50/25 font-semibold rounded-lg transition-colors text-sm whitespace-nowrap cursor-pointer"
                >
                  查看热度榜单
                  <i className="ri-fire-line ml-2"></i>
                </a>
              </div>
            </div>

            <div className="flex-1 w-full max-w-lg lg:max-w-none">
              <div className="relative rounded-2xl overflow-hidden aspect-[4/3]">
                <img
                  src="https://readdy.ai/api/search-image?query=Cinematic%20abstract%20composition%20with%20glowing%20warm%20neon%20orange%20and%20amber%20rings%2C%20modern%20minimalist%20streaming%20interface%20concept%2C%20floating%20translucent%20glass%20panels%2C%20dark%20sophisticated%20background%20with%20soft%20bokeh%20lights%2C%20premium%20digital%20entertainment%20aesthetic%2C%204k%20cinematic%20mood&width=800&height=600&seq=durian-hero-visual&orientation=landscape"
                  alt="榴莲视频平台主视觉 - 在线视频平台综合对比导航"
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
                <div className="absolute bottom-4 left-4 right-4 flex items-center gap-2">
                  <span className="px-3 py-1.5 rounded-full bg-background-50/20 backdrop-blur-sm text-xs text-background-100 border border-background-50/20 whitespace-nowrap">
                    97视频
                  </span>
                  <span className="px-3 py-1.5 rounded-full bg-background-50/20 backdrop-blur-sm text-xs text-background-100 border border-background-50/20 whitespace-nowrap">
                    糖心视频
                  </span>
                  <span className="px-3 py-1.5 rounded-full bg-background-50/20 backdrop-blur-sm text-xs text-background-100 border border-background-50/20 whitespace-nowrap">
                    黑桃视频
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}